import { Route } from 'src/routes/Route'

export const FourOFourRoute = Route({ path: '/404' })
export type FourOFourRoute = Route<typeof FourOFourRoute>
